var Backbone = require('backbone/backbone');
var _ = require('underscore/underscore');
require('velocity-animate/velocity.min.js');
require('velocity-animate/velocity.ui.min.js');

require('./ArticlesList.less');

var Grid = require('front/components/Grid/Grid');

module.exports = Backbone.View.extend({
    el: '.ArticlesList',

    events: {
        'click .ArticlesList-btn .Button': 'loadMore'
    },

    initialize: function (options) {
        this.options = options || {};
        this.apiUrl = options.apiUrl || window.app.settings.urls.api.articles;
        this.limit = options.limit || 21;

        this.state = {
            count: 0
        };

        if (!this.$el.size()) {
            return false;
        }

        this.$list = this.$('.ArticlesList-inner');
        this.$loadButton = this.$('.ArticlesList-btn');

        _.each(this.$('.Grid'), function (el) {
            var grid = new Grid({
                el: el
            });

            this.state.count += grid.count;
        }, this);
    },

    onLoad: function (html) {
        if (html) {
            var $el = $(html).appendTo(this.$list);

            var oldH = this.$list.outerHeight();
            $.Velocity.hook(this.$list, 'height', oldH + 'px');

            var $gridHidden = this.$('.Grid.Grid--isHidden');
            $.Velocity.hook($gridHidden, 'opacity', '0');
            $gridHidden.removeClass('Grid--isHidden');

            $.Velocity.hook(this.$list, 'height', 'auto');
            var newH = this.$list.outerHeight();
            $.Velocity.hook(this.$list, 'height', oldH + 'px');

            $.Velocity.animate(this.$list[0], {height: newH}, {duration: 750});
            $.Velocity.animate($gridHidden, {opacity: 1}, {duration: 1500});

            var grid = new Grid({
                el: $el
            });

            if ($el.data('has-more') === 'False') {
                this.$loadButton.fadeOut();
            } else {
                this.state.count += this.limit;
            }

            HC.widget('Counter', {
                widget: 'Counter',
                widget_id: window.HC_WIDGET_ID,
                selector: '.u-CommentCount',
                label: '{%COUNT%}'
            }, 'add');
        }
    },

    loadMore: function () {
        $.ajax(this.apiUrl, {
            type: 'get',
            dataType: 'html',
            data: _.extend({}, this.options.dataOptions, {
                loaded: this.state.count,
                limit: this.limit
            }),
            success: this.onLoad,
            context: this
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/ArticlesList/ArticlesList.js
// module id = 5
// module chunks = 0